import { useRef, useState } from "react";
import { IoMdClose } from "react-icons/io";
import { handleBuyCredit } from "./buyCredit";
import { useDispatch, useSelector } from "react-redux";
import { setMyCredit } from "../../redux/user/user.actions";

export const BuyCredits = ({ credit, price, cardSaved, closeModal }) => {
  // const [price, setPrice] = useState(0);
  // const [credit, setCredit] = useState(0);

  // const claculateCredit = (e) => {
  //   const pricePerCredit = 0.05;
  //   const price = e.target.value;
  //   setCredit(price / pricePerCredit);
  //   setPrice(price);
  // }

  return (
    <div
      className="modal fade"
      id="buyCredits"
      data-backdrop="static"
      data-keyboard="false"
      tabindex="-1"
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
    >
      {cardSaved ? (
        <PurchaseConfirmation
          price={price}
          credit={credit}
          closeModal={closeModal}
        />
      ) : (
        <AddCardBody />
      )}
    </div>
  );
};

export const AddCardBody = () => {
  return (
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content bg-dark py-2 px-2">
        <div className="modal-header border-0 pb-0 pt-2">
          <h4 className="modal-title text-white" id="staticBackdropLabel">
            Please Add Card
          </h4>
          <button
            type="button"
            className="btn btn-link p-0 text-white"
            data-dismiss="modal"
            aria-label="Close"
          >
            <IoMdClose fontSize="25px" />
          </button>
        </div>
        <div className="modal-body">
          <div className="row">
            <div className="col-md-12">
              <p className="text-white f-14">
                Please add a Card to purchase credits.
              </p>
            </div>
          </div>
        </div>

        <div className="modal-footer border-0">
          <button
            type="button"
            className="btn btn-secondary btn-sm bg-white text-dark"
            data-dismiss="modal"
            style={{ minWidth: 80 }}
          >
            Ok
          </button>
        </div>
      </div>
    </div>
  );
}

export const PurchaseConfirmation = ({ price, credit, closeModal }) => {
  const dispatch = useDispatch();

  const closeButtonRef = useRef();
  const userId = useSelector((state) => state.user.userId);
  const userCredit = useSelector((state) => state.user.mycredits);

  const handleSubmit = async () => {
    const status = await handleBuyCredit("one-time", price, credit, userId);
    console.log({status})
    if (status === "succeeded") {
      dispatch(setMyCredit(userCredit + credit));
      closeButtonRef.current?.click();
      closeModal();
    }
  };

  return (
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content bg-dark py-2 px-2">
        <div className="modal-header border-0 pb-0 pt-2">
          <h4 className="modal-title text-white" id="staticBackdropLabel">
            Confirm Purchase
          </h4>
          <button
            type="button"
            className="btn btn-link p-0 text-white"
            data-dismiss="modal"
            aria-label="Close"
          >
            <IoMdClose fontSize="25px" />
          </button>
        </div>
        <div className="modal-body">
          <div className="row">
            <div className="col-md-12">
              <p className="text-white f-14">
                You confirm a one-time purchase of ${price}.00 for {credit}{" "}
                credits.
              </p>
            </div>
          </div>
        </div>

        <div className="modal-footer border-0">
          <button
            ref={closeButtonRef}
            type="button"
            className="btn btn-secondary btn-sm bg-white text-dark"
            data-dismiss="modal"
            style={{ minWidth: 80 }}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-primary btn-sm"
            style={{ minWidth: 80 }}
            onClick={handleSubmit}
          >
            Buy
          </button>
        </div>
      </div>
    </div>
  );
};